// === ОБРАБОТЧИКИ КАРТЫ ===
import { map } from './map';
import { detectorControls, Mode, state } from '../app';
import { MessageToast } from '../ui/components/toast';
import { CRITICAL_VALUE } from 'scripts/api/sector';
import { Detector } from 'scripts/classes/detector';
import { onDemPointPicked } from '../ui/demDownload';

map.on('click', (e: any) => {

    const coordinates = e.lngLat;

    // Выбор центра области для загрузки рельефа (DEM): один клик → координаты
    // попадают в форму загрузки, маркер ставится на карту.
    if (state.mode === Mode.waitForDemPoint) {
        onDemPointPicked(coordinates.lat, coordinates.lng);
        return;
    }

    // Просто просматривает карту
    if (state.mode === Mode.justWatching) {
        if (!state.folder) {
            MessageToast.showDanger("1", "Выберите папку!");
            return;
        }
        return;
    }
    
    // Ставит первую точку
    if (state.mode === Mode.waitForPoint) {

        if (!state.folder) {
            MessageToast.showDanger("1", "Выберите папку!");
            return;
        }
        const distance = parseFloat(localStorage.getItem(CRITICAL_VALUE) ?? "800");
        const coneWidth = detectorControls.cone.getCone();

        if(!state.detector){
            state.detector = new Detector('temp', coordinates.lat, coordinates.lng, distance, coneWidth, true);
        } else {
            state.detector.lat = coordinates.lat;
            state.detector.lng = coordinates.lng;
            state.detector.distance = distance;
            state.detector.coneWidth = coneWidth
        }
        state.detector.drawMarker();

        //TODO: добавляю +1 к координатам марки, чтобы азмут был больше 0 и сектор отрисовался. ПРОВЕРИТЬ и убрать +1
        state.detector.setAzimuth(coordinates.lat+1, coordinates.lng+1);
        state.detector.drawSector();

        detectorControls.coords.setCoords(coordinates.lat, coordinates.lng);

        detectorControls.reset.setEnable();

        state.mode = Mode.waitingForDirection; 

        return;
    }

    // Ставит направление
    if (state.mode === Mode.waitingForDirection) {
        if(state.detector){
            state.detector.setAzimuth(coordinates.lat, coordinates.lng);
            state.detector.drawSector();
            
            detectorControls.coords.setAzimuth(state.detector.azimuth ?? 0);
            detectorControls.coords.setCoords(coordinates.lat, coordinates.lng);
        }
        detectorControls.save.setEnable();
        state.mode = Mode.complete;
        return;
    }

});

// Движение сектора при выборе направления
map.on('mousemove', (e) => {
    if (state.mode === Mode.waitingForDirection && state.detector) {
        state.detector.setAzimuth(e.lngLat.lat, e.lngLat.lng);
        state.detector.sector?.redraw();

        detectorControls.coords.setAzimuth(state.detector.azimuth ?? 0);
    }
});